(() => {
  const HEADING = 'Stay Ahead with TREEDIX';
  const COPY = 'Get product launches, technical updates and practical electronics insights.';
  const BUTTON = 'Subscribe';
  const SUCCESS_TEXT = 'Thanks for subscribing.';

  function textIsOld(value, oldValues) {
    const text = (value || '').trim();
    return !text || oldValues.includes(text);
  }

  function initNewsletter(root = document) {
    const section = root.querySelector('.tl-newsletter');
    if (!section) return;

    const title = section.querySelector('.newsletter-title, .tl-newsletter__copy h2');
    const copy = section.querySelector('.tl-newsletter__copy .tl-copy, .tl-newsletter__copy p');
    const form = section.querySelector('form.tl-newsletter__form, form[action*="/contact"]');
    const input = form && form.querySelector('input[type="email"]');
    const button = form && form.querySelector('button[type="submit"]');

    if (title && textIsOld(title.textContent, ['Stay Updated'])) title.textContent = HEADING;
    if (copy && textIsOld(copy.textContent, ['New products, updates and offers.'])) copy.textContent = COPY;

    if (input && !input.getAttribute('placeholder')) input.setAttribute('placeholder', 'Enter your email');

    if (button) {
      button.textContent = BUTTON;
      button.setAttribute('aria-label', BUTTON);
    }

    if (!form) return;

    const existingSuccess = form.querySelector('.newsletter-success, .form-status--success, .treedix-newsletter-form__message--success, .treedix-newsletter-message--success');
    if (existingSuccess) {
      existingSuccess.classList.add('treedix-newsletter-success-message');
      existingSuccess.textContent = SUCCESS_TEXT;
      existingSuccess.hidden = false;
    }

    const params = new URLSearchParams(window.location.search);
    if (params.get('customer_posted') === 'true') {
      let message = form.querySelector('[data-treedix-newsletter-success="true"]');
      if (!message) {
        message = document.createElement('p');
        message.dataset.treedixNewsletterSuccess = 'true';
        form.appendChild(message);
      }
      message.className = 'treedix-newsletter-success-message newsletter-success form-status--success';
      message.setAttribute('role', 'status');
      message.textContent = SUCCESS_TEXT;
      message.hidden = false;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initNewsletter(document));
  } else {
    initNewsletter(document);
  }

  document.addEventListener('shopify:section:load', (event) => initNewsletter(event.target));
})();
